import React from 'react';
import { Button, message, Space, Upload, Table } from 'antd';
import { UploadOutlined, CheckCircleOutlined, SyncOutlined, CloseCircleOutlined } from '@ant-design/icons';

class FileUpload extends React.Component {
  state = {
    fileList: [],
  };

  handleFileSubmit = async (file) => {
    const { onFileUpload } = this.props;
    this.updateFileList(file, { status: 'uploading' });

    try {
      await onFileUpload([file]);
      this.updateFileList(file, { status: 'done' });
      message.success(`${file.name} uploaded successfully`);
    } catch (error) {
      this.updateFileList(file, { status: 'error' });
      message.error(`Upload failed for ${file.name}: ${error.message}`);
    }
  };
  // Handle uploading multiple files sequentially
  handleMultipleFileSubmit = async () => {
    const { fileList } = this.state;
    for (const file of fileList) {
      if (file.status === 'not_started') {
        await this.handleFileSubmit(file);  // Ensure one file is handled at a time
      }
    }
  };


  updateFileList = (file, updates) => {
    const newList = this.state.fileList.map(f => {
      if (f.uid === file.uid) {
        return { ...f, ...updates };
      }
      return f;
    });
    this.setState({ fileList: newList });
  };

  beforeUpload = (file) => {
    return false; // Prevent automatic uploads
  };

  handleChange = (info) => {
    const newFileList = info.fileList.map(file => ({
      ...file,
      status: file.status || 'not_started',
    }));

    this.setState({ fileList: newFileList });
  };

  columns = [
    {
      title: 'Status',
      key: 'status',
      render: (_, file) => {
        let icon;
        let color;
        switch (file.status) {
          case 'uploading':
            icon = <SyncOutlined spin />;
            color = 'blue';
            break;
          case 'done':
            icon = <CheckCircleOutlined />;
            color = 'green';
            break;
          case 'error':
            icon = <CloseCircleOutlined />;
            color = 'red';
            break;
          default:
            icon = <UploadOutlined />;
            color = 'gray';
        }
        return <span style={{ color }}>{icon}</span>;
      },
    },
    {
      title: 'File Name',
      dataIndex: 'name',
      key: 'name',
    },
    {
      title: 'Actions',
      key: 'actions',
      render: (_, file) => (
        <Button
          onClick={() => this.handleFileSubmit(file)}
          disabled={file.status === 'uploading' || file.status === 'done'}
          icon={<UploadOutlined />}
        >
          Upload
        </Button>
      ),
    },
  ];

  render() {
    return (
      <Space direction="vertical" style={{ width: '100%' }}>
        <Upload
          {...this.props}
          beforeUpload={this.beforeUpload}
          onChange={this.handleChange}
          multiple={true}
          fileList={this.state.fileList}
          itemRender={() => null} // Disable default item rendering
        >
          <Button icon={<UploadOutlined />}>Select Files</Button>
        </Upload>
        <Table columns={this.columns} dataSource={this.state.fileList} pagination={false} />
        <Button
          onClick={this.handleMultipleFileSubmit}
          disabled={!this.state.fileList.length || this.state.fileList.every(file => file.status === 'done' || file.status === 'uploading')}
          type="primary"
        >
          Upload All
        </Button>
      </Space>
    );
  }
}

export default FileUpload;
